import { render, staticRenderFns } from "./IndoorsDataDetails.vue?vue&type=template&id=0d067434&scoped=true"
import script from "./IndoorsDataDetails.vue?vue&type=script&lang=js"
export * from "./IndoorsDataDetails.vue?vue&type=script&lang=js"
import style0 from "./IndoorsDataDetails.vue?vue&type=style&index=0&id=0d067434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d067434",
  null
  
)

export default component.exports